export const syncTags = (context) => (id, apply) => ({
    type: "CMS.INTEGRATIONS.SYNC_TAGS",
    payload: { id, apply },
    context,
});
